import React from "react";
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/HoldingInsurance.scss";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { createSearchParams, useNavigate } from "react-router-dom";
import { AssetCategory } from "@domains/aggregates/interfaces/Reports/iPNLReport";
const InsuranceReportBanner = (props) => {
    const navigate = useNavigate();
    const device = DeviceContext();
    const handleClick = () => {
        props === null || props === void 0 ? void 0 : props.setIsInsuranceVisited(true);
        navigate({
            pathname: "",
            search: createSearchParams({
                reportName: "Holding",
            }).toString(),
        }, {
            state: {
                goToHoldingAssetTab: {
                    assetCategory: AssetCategory.LifeInsurance,
                },
            },
        });
    };
    return (React.createElement("div", { className: "new-life-insurance-banner my-3" },
        React.createElement("div", { className: "new-keyword" }, "New"),
        React.createElement("div", { className: "live-msg" },
            "Now Live: Track all your Life Insurance Investments in one place.",
            !(device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", null,
                "See",
                " ",
                React.createElement("span", { onClick: handleClick, className: "text-decoration-underline", role: "button" }, "Life Insurance Report"))))));
};
export default React.memo(InsuranceReportBanner);
